export default __webpack_public_path__ + "static/media/nano-gif.4abf8b7f.gif";